import Filter from "../components/Filters/Filter";
import PostsGrid from "../components/Grid/PostsGrid";


export default function BlogsPage() {
    return (
        <section className="wrapper">
            <Filter/>
            <PostsGrid/>
        </section>
    )
};